import { useRef, useState } from "react";
import Navbar from "../layout/Navbar";
import job_application from "../assests/Images/job_application.jpg";
import contact_img from "../assests/Images/Contact.jpg";
import Location_img from "../assests/Images/Location.png";
import Footer from "../layout/Footer";
import emailjs from "@emailjs/browser";
import { useForm } from "react-hook-form";
import Toast from "../Components/Toast";

const Contact = () => {
  const [showToast, setShowToast] = useState("");
  const {
    register,
    handleSubmit,
    formState: { errors },
  } = useForm();

  const formRef = useRef(null);
  const serviceId = process.env.REACT_APP_EMAIL_JS_SERVICE_ID || "";
  const templateId = process.env.REACT_APP_EMAIL_JS_TEMP_ID || "";
  const publicId = process.env.REACT_APP_EMAIL_JS_PUBLIC_ID || "";

  const handleOnSubmit = () => {
    if (formRef.current) {
      emailjs
        .sendForm(serviceId, templateId, formRef.current, {
          publicKey: publicId,
        })
        .then((response) => {
          if (response.status === 200) {
            setShowToast({
              message: "Request sent successfully!",
              type: "success",
            });
            formRef.current.reset();
          } else if (response.status === 400) {
            setShowToast({
              message: "Bad request. Please check the form.",
              type: "error",
            });
          } else if (response.status === 500) {
            setShowToast({
              message: "Server error. Try again later.",
              type: "error",
            });
          } else {
            setShowToast({
              message: `Error: ${response.statusText}`,
              type: "error",
            });
          }
        })
        .catch((error) => {
          console.error("EmailJS Error:", error);
          setShowToast({
            message: "Failed to send request. Please try again.",
            type: "error",
          });
        });
    }
  };

  return (
    <>
      <Navbar />
      <section className="relative h-[60vh] md:h-[500px] lg:h-[75vh] w-full lg:rounded-tl-[360px] overflow-hidden">
        <img
          src={job_application}
          alt="Job Application"
          className="object-cover w-full h-full"
        />

        <div className="absolute inset-0 bg-black/70 flex flex-col justify-center items-center gap-4 px-4 text-center">
          <h1 className="text-white text-3xl md:text-5xl lg:text-7xl font-bold leading-tight">
            Get In Touch
          </h1>

          <p className="text-gray-200 text-sm md:text-lg lg:text-2xl max-w-3xl">
            Smarter Business Solutions. Better Customer Relations.
          </p>
        </div>
      </section>

      <section className="grid grid-cols-1 lg:grid-cols-2 gap-10 m-4 lg:m-16 items-center">
        <div className="flex justify-center">
          <img
            src={contact_img}
            alt="Contact"
            className="max-w-full rounded-xl"
          />
        </div>

        <div className="bg-white shadow-xl rounded-xl p-6 lg:p-10">
          <h1 className="text-center text-2xl xl:text-3xl font-bold mb-8">
            What are you looking for?
          </h1>

          <form
            ref={formRef}
            className="grid grid-cols-1 lg:grid-cols-2 gap-5 lg:gap-x-10"
            onSubmit={handleSubmit(handleOnSubmit)}
          >
            <div className="flex flex-col">
              <label>
                Your Name <span className="text-red-500">*</span>
              </label>
              <input
                className="border border-gray-300 rounded-md px-3 py-2 focus:ring-2 focus:ring-primary"
                {...register("name", {
                  required: "Name is required",
                })}
              />
              {errors.name && (
                <p className="text-red-500 text-sm">{errors.name.message}</p>
              )}
            </div>

            <div className="flex flex-col">
              <label>
                Your Organization <span className="text-red-500">*</span>
              </label>
              <input
                className="border border-gray-300 rounded-md px-3 py-2 focus:ring-2 focus:ring-primary"
                {...register("organization", {
                  required: "Organization name is required",
                })}
              />
              {errors.organization && (
                <p className="text-red-500 text-sm">
                  {errors.organization.message}
                </p>
              )}
            </div>

            <div className="flex flex-col">
              <label>
                Industry Name <span className="text-red-500">*</span>
              </label>
              <input
                className="border border-gray-300 rounded-md px-3 py-2 focus:ring-2 focus:ring-primary"
                {...register("industry", {
                  required: "Industry is required",
                })}
              />
              {errors.industry && (
                <p className="text-red-500 text-sm">
                  {errors.industry.message}
                </p>
              )}
            </div>

            <div className="flex flex-col">
              <label>
                Your Designation <span className="text-red-500">*</span>
              </label>
              <input
                className="border border-gray-300 rounded-md px-3 py-2 focus:ring-2 focus:ring-primary"
                {...register("designation", {
                  required: "Designation is required",
                })}
              />
              {errors.designation && (
                <p className="text-red-500 text-sm">
                  {errors.designation.message}
                </p>
              )}
            </div>

            <div className="flex flex-col">
              <label>
                Your Mobile Number <span className="text-red-500">*</span>
              </label>
              <input
                className="border border-gray-300 rounded-md px-3 py-2 focus:ring-2 focus:ring-primary"
                {...register("number", {
                  required: "Number is required",
                  pattern: {
                    value: /^(?:\+91[-\s]?|0)?[6-9]\d{9}$/,
                    message: "Enter a valid 10-digit  mobile number",
                  },
                })}
              />
              {errors.number && (
                <p className="text-red-500 text-sm">{errors.number.message}</p>
              )}
            </div>

            <div className="flex flex-col">
              <label>
                Your Email Address <span className="text-red-500">*</span>
              </label>
              <input
                className="border border-gray-300 rounded-md px-3 py-2 focus:ring-2 focus:ring-primary"
                {...register("email", {
                  required: "Email is required",
                  pattern: {
                    value: /^\S+@\S+\.\S+$/,
                    message: "Enter a valid email address",
                  },
                })}
              />
              {errors.email && (
                <p className="text-red-500 text-sm">{errors.email.message}</p>
              )}
            </div>

            <div className="lg:col-span-2 flex flex-col">
              <label>
                Tell Us about Your Requirement{" "}
                <span className="text-red-500">*</span>
              </label>
              <textarea
                rows="4"
                className="border border-gray-300 rounded-md px-3 py-2 focus:ring-2 focus:ring-primary"
                {...register("message", {
                  required: "Message is required",
                  maxLength: {
                    value: 250,
                    message: "Message must not exceed 250 characters",
                  },
                })}
              />
              {errors.message && (
                <p className="text-red-500 text-sm">{errors.message.message}</p>
              )}
            </div>

            <div className="lg:col-span-2">
              <button
                type="submit"
                className="w-full bg-primary text-white font-semibold py-3 rounded-md hover:bg-red-900 transition"
              >
                Submit
              </button>
            </div>
          </form>
        </div>

        {showToast && (
          <Toast
            message={showToast.message}
            type={showToast.type}
            onClose={() => setShowToast("")}
          />
        )}
      </section>
      <Footer />
    </>
  );
};

export default Contact;
